import React, { Component, ReactNode } from 'react';
import GatewayContainer from '../../../config/GatewayContainer';
import GatewayNames from '../../../constant/GatewayNames';
import HttpClient from '../../../gateway/HttpClient';
import HttpMethod from '../../../constant/HttpMethod';
import CustomTable from '../../custom/CustomTable';
import moment from 'moment';
import LanguageUtil from '../../../util/LanguageUtil';

class SessionContainer extends Component<{}, State> {
  public state = new State();

  private readonly client: HttpClient = GatewayContainer.getInstance().get(GatewayNames.API_CLIENT);

  public render(): ReactNode {
    const { sessions } = this.state;
    return (
      <div className={'flex w-full h-full items-center px-5 py-5 '}>
        <CustomTable columns={this.getColumns()} value={sessions} />
      </div>
    );
  }

  public async componentDidMount() {
    const response: KeycloakSessionResponse[] = await this.client.execute(HttpMethod.GET, 'rbac/sessions');
    this.setState({ sessions: response });
  }

  private getColumns() {
    return [
      {
        field: 'username',
        header: LanguageUtil.get({ id: 'common.label.user', defaultMessage: 'User' }),
        className: 'min-w-[33%]',
        body: (data: KeycloakSessionResponse) => (
          <div>
            <span className={'text-sm 2xl:text-md pl-3 2xl:pl-4 font-medium'}>{data.username}</span>
          </div>
        ),
      },
      {
        field: 'ipAddress',
        header: LanguageUtil.get({ id: 'common.label.ipAddress', defaultMessage: 'Ip Address' }),
        className: 'min-w-[33%]',
      },
      {
        field: 'lastAccess',
        header: LanguageUtil.get({ id: 'common.label.lastAccess', defaultMessage: 'Last Access' }),
        className: 'min-w-[33%]',
        body: (data: KeycloakSessionResponse) => moment(data.lastAccess).format('LLL'),
      },
    ];
  }
}

class State {
  sessions: KeycloakSessionResponse[] = [];
}

interface KeycloakSessionResponse {
  id: string;
  ipAddress: string;
  lastAccess: number;
  start: number;
  userId: string;
  username: string;
}

export default SessionContainer;
